import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import "./i18n";
import { CMSProvider } from "./context/CMSContext";

/* GA4（可選）：設定 VITE_GA_ID 建置變數即啟用；留空 = 完全不載入 */
const GA_ID = import.meta.env.VITE_GA_ID as string | undefined;
if (GA_ID) {
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  const w = window as any;
  w.dataLayer = w.dataLayer || [];
  w.gtag = function (...args: unknown[]) { w.dataLayer.push(args); };
  w.gtag("js", new Date());
  w.gtag("config", GA_ID, { anonymize_ip: true });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <CMSProvider>
      <App />
    </CMSProvider>
  </StrictMode>
);
